import React from "react";
import styled from "styled-components";
import BecomeHost1 from "../../../../public/images/become-host/become-host-1.jpg";
import BecomeHost2 from "../../../../public/images/become-host/become-host-2.jpeg";
import BecomeHost3 from "../../../../public/images/become-host/become-host-3.jpeg";
import BecomeHost4 from "../../../../public/images/become-host/become-host-4.jpeg";
import Portraits from "../../../../public/images/become-host/portraits.png";
import DoubleQuotes from "../../../../public/images/become-host/double-quotes.png";
import Person from "../../../../public/images/become-host/geraldine.jpg";

import { Link } from "react-router-dom";

import { textTranslation, shouldTranslateTo } from "../utils/utils";

import { Button } from "./Utils/CustomClasses";

// import { Container } from './styles';

const Container = styled.div`
    display: flex;
    flex-direction: column;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 0px;
    }
`;

const Row = styled.div`
    display: flex;
    gap: ${(props) => (props.gap ? props.gap : "120px")};
    justify-content: center;
    flex-direction: row;
    padding: 75px 110px;

    @media (max-width: 1024px) {
        gap: ${(props) => (props.gap1024 ? props.gap1024 : "80px")};
        padding: 75px 80px;
    }

    & > div {
        @media (max-width: 768px) {
            width: 100%;
        }
    }

    &:nth-of-type(even) {
        background-color: rgba(188, 188, 188, 0.5);
    }

    @media (max-width: 768px) {
        flex-direction: ${(props) =>
            props.reverse ? "column-reverse" : "column"};
        gap: 30px;
        padding: 35px 3vw;

        & > div {
            padding: 0 20px;
        }
    }
`;

const Tittle = styled.h1`
    color: #274653;
    font-size: ${(props) => (props.size ? props.size : "50px")};
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: ${(props) =>
        props.marginBottom ? props.marginBottom : "31px"};

    @media (max-width: 768px) {
        font-size: ${(props) => (props.sizeMobile ? props.size : "26px")};
    }
`;

const Subtittle = styled.h4`
    color: ${(props) => (props.white ? "#fff" : "#274653")};
    font-size: ${(props) => (props.size ? props.size : "20px")};
    font-style: normal;
    font-weight: 700;
    line-height: 130%; /* 39px */
    margin-bottom: ${(props) =>
        props.marginBottom ? props.marginBottom : "40px"};

    @media (max-width: 768px) {
        font-size: ${(props) => (props.sizeMobile ? props.size : "20px")};
        margin-bottom: ${(props) =>
            props.marginBottomMobile ? props.marginBottomMobile : "0px"};
    }
`;

const Text = styled.p`
    color: ${(props) => (props.white ? "#fff" : "#274653")};
    font-size: ${(props) => (props.size ? props.size : "20px")};
    font-style: normal;
    font-weight: ${(props) => (props.bold ? "bold" : "500")};
    line-height: 140%; /* 36.4px */
    letter-spacing: -0.26px;
    margin: ${(props) => (props.margin ? props.margin : "0")};

    ${(props) => (props.marginBottom ? `margin-bottom: 39px;` : "")};

    @media (max-width: 1025px) {
        font-size: ${(props) => (props.size1024 ? props.size1024 : "20px")};
    }

    @media (max-width: 768px) {
        font-size: ${(props) => (props.sizeMobile ? props.size : "20px")};
    }
`;

const CustomButton = styled(Button)`
    width: ${(props) => (props.fullWidth ? "100%" : "250px")};
    height: auto;
    background: #f4a261;
    color: #fff;
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    letter-spacing: -0.18px;
    border-radius: 4px;
    border: none;
    margin-top: 25px;
    padding-block: 7px;

    a {
        font-weight: 700;
        text-decoration: none;
        color: #fff;
    }
`;

const List = styled.ul`
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 153%;
    list-style-type: circle;

    li {
        list-style: inside none disc !important;
        margin: 0 0 20px;
    }

    @media (max-width: 1024px) {
        font-size: 18px;

        li {
            margin: 0px 0px 21px 0px;
        }
    }
`;

const DarkCard = styled.div`
    width: 100vw;
    padding: 35px 50px;
    background: #274653;
    color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    @media (max-width: 1025px) {
        padding: 35px 40px;
        width: 150vw;
    }

    @media (max-width: 768px) {
        width: 100vw;
        padding: 35px 20px !important;
    }
`;

const Image = styled.div`
    display: flex;
    align-items: center;
    overflow: hidden;
    height: auto;
    width: 80%;

    img {
        max-width: -webkit-fill-available;
        @media (max-width: 768px) {
            max-width: calc(100vw - 80px);
        }
    }
`;

const ImageCover = styled.div`
    width: 50%;
    display: flex;
    align-items: flex-start;
    overflow: hidden;
    background-size: cover;
    background-image: ${(props) =>
        props.image ? `url(${props.image})` : "none"};

    @media (max-width: 768px) {
        height: 20vh;
    }
`;

const SideText = styled.div`
    width: ${(props) => (props.width ? props.width : "auto")};
    display: flex;
    flex-direction: column;
    align-items: ${(props) => (props.center ? "center" : "flex-start")};
    justify-content: center;

    ${(props) => props.center && "width: 90%"};
    ${(props) => props.center && "text-align: center;"}

    @media (max-width: 768px) {
        ${(props) => props.center && "width: 100%;"}
    }
`;

const BackgroundRow = styled.div`
    display: flex;
    height: 435px;
    background: linear-gradient(
            180deg,
            rgba(39, 70, 83, 1),
            rgba(39, 70, 83, 0.9) 100%
        ),
        ${(props) => (props.image ? `url(${props.image})` : "none")};

    @media (max-width: 768px) {
        height: 80vh;
    }

    & > img {
        position: absolute;

        @media (max-width: 768px) {
            width: 100px;
            margin: 10px;
        }
    }
`;

const Testimonial = styled.div`
    opacity: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;

    @media (max-width: 768px) {
        flex-direction: column;
    }

    & > img {
        width: 200px;
        height: 220px;
        border-radius: 0px 40px;
        box-shadow: -25px 25px #1a2c34;

        @media (max-width: 768px) {
            box-shadow: -15px 15px #1a2c34;
            width: 100px;
            height: 110px;
        }
    }
`;

const TestimonialText = styled.div`
    height: 220px;
    width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    margin-left: 60px;

    @media (max-width: 768px) {
        margin-left: 0;
        margin-top: 30px;
        display: inline-table;
        width: 80%;
    }

    h4 {
        font-size: 23px;
        color: #f4a261;
        font-style: normal;
        font-weight: 700;
        line-height: 140%; /* 32.172px */
        letter-spacing: 1.838px;
    }

    h5 {
        color: #fff;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%; /* 22.372px */
    }
`;

const BecomeHost = () => {
    const [pageText, setPageText] = React.useState([]);

    React.useEffect(() => {
        const language = shouldTranslateTo();
        const getPageText = (pageValue, languageValue) => {
            axios
                .get(`/api/page-text/${pageValue}/${languageValue}`)
                .then((response) => {
                    let pageText = response.data.map((textItem) => {
                        return textItem.text;
                    });

                    setPageText(pageText);
                    // this.setState({
                    //   footerData: pageText
                    // });
                })
                .catch((err) => {
                    console.log("Error getting page text: ", err);
                });
        };

        getPageText("become-host", language);
    }, []);

    React.useEffect(() => {
        console.log(pageText);
    }, [pageText]);

    return (
        <div>
            <Container>
                {/* <Row reverse gap='55px'>
          <SideText width='50%'>
            <Subtittle size='36px' dangerouslySetInnerHTML={{ __html: pageText[26]}}></Subtittle>
            <Text size='18px' dangerouslySetInnerHTML={{ __html: pageText[27] }}></Text>
            <Subtittle size='18px' dangerouslySetInnerHTML={{ __html: pageText[28]}}></Subtittle>
          </SideText>
          <ImageCover image={BecomeHostSide2}>
            <img src={BecomeHostSide2} alt="Become a Host" /> 
          </ImageCover>
        </Row> */}
                <Row gap="80px" gap1024="30px">
                    <div>
                        <Tittle
                            marginBottom="23px"
                            dangerouslySetInnerHTML={{ __html: pageText[0] }}
                        ></Tittle>
                        <Subtittle
                            marginBottom="23px"
                            marginBottomMobile="15px"
                            size="22px"
                            dangerouslySetInnerHTML={{ __html: pageText[26] }}
                        ></Subtittle>
                        <Text
                            size="18px"
                            size1024="18px"
                            marginBottom="20px"
                            dangerouslySetInnerHTML={{ __html: pageText[27] }}
                        ></Text>
                        <Subtittle
                            marginBottom="23px"
                            size="22px"
                            dangerouslySetInnerHTML={{ __html: pageText[28] }}
                        ></Subtittle>
                        <Text
                            size="18px"
                            size1024="18px"
                            margin="20px 0 0"
                            dangerouslySetInnerHTML={{ __html: pageText[30] }}
                        ></Text>
                    </div>
                    <DarkCard>
                        <div>
                            <Subtittle
                                white
                                size="26px"
                                dangerouslySetInnerHTML={{
                                    __html: pageText[3],
                                }}
                            ></Subtittle>
                            <List>
                                <li
                                    dangerouslySetInnerHTML={{
                                        __html: pageText[4],
                                    }}
                                ></li>
                                <li
                                    dangerouslySetInnerHTML={{
                                        __html: pageText[5],
                                    }}
                                ></li>
                                <li
                                    dangerouslySetInnerHTML={{
                                        __html: pageText[6],
                                    }}
                                ></li>
                                <li
                                    dangerouslySetInnerHTML={{
                                        __html: pageText[7],
                                    }}
                                ></li>
                                <li
                                    dangerouslySetInnerHTML={{
                                        __html: pageText[29],
                                    }}
                                ></li>
                                <li
                                    dangerouslySetInnerHTML={{
                                        __html: pageText[31],
                                    }}
                                ></li>
                            </List>
                        </div>
                        <CustomButton fullWidth>
                            <Link
                                to="/dashboard/edit-place"
                                dangerouslySetInnerHTML={{
                                    __html: pageText[8],
                                }}
                            ></Link>
                        </CustomButton>
                    </DarkCard>
                </Row>
                <Row gap="120px">
                    <Image>
                        <img src={BecomeHost1} alt="Become a Host" />
                    </Image>
                    <SideText width="100%">
                        <Subtittle
                            size="36px"
                            dangerouslySetInnerHTML={{ __html: pageText[9] }}
                        ></Subtittle>
                        <Text
                            size="18px"
                            dangerouslySetInnerHTML={{ __html: pageText[10] }}
                        ></Text>
                    </SideText>
                </Row>
                <Row reverse>
                    <SideText width="100%">
                        <Subtittle
                            size="36px"
                            dangerouslySetInnerHTML={{ __html: pageText[11] }}
                        ></Subtittle>
                        <Text
                            size="18px"
                            dangerouslySetInnerHTML={{ __html: pageText[12] }}
                        ></Text>
                    </SideText>
                    <Image>
                        <img src={BecomeHost2} alt="Become a Host" />
                    </Image>
                </Row>
                <Row>
                    <SideText center>
                        <Subtittle
                            size="29px"
                            dangerouslySetInnerHTML={{ __html: pageText[13] }}
                        ></Subtittle>
                        <Text
                            size="18px"
                            dangerouslySetInnerHTML={{ __html: pageText[14] }}
                        ></Text>
                        <CustomButton>
                            <Link
                                to="/dashboard/edit-place"
                                dangerouslySetInnerHTML={{
                                    __html: pageText[15],
                                }}
                            ></Link>
                        </CustomButton>
                    </SideText>
                </Row>
                <Row>
                    <Image>
                        <img src={BecomeHost3} alt="Become a Host" />
                    </Image>
                    <SideText width="100%">
                        <Subtittle
                            size="36px"
                            dangerouslySetInnerHTML={{ __html: pageText[16] }}
                        ></Subtittle>
                        <Text
                            size="18px"
                            dangerouslySetInnerHTML={{ __html: pageText[17] }}
                        ></Text>
                    </SideText>
                </Row>
                <Row reverse>
                    <SideText width="100%">
                        <Subtittle
                            size="36px"
                            dangerouslySetInnerHTML={{ __html: pageText[18] }}
                        ></Subtittle>
                        <Text
                            size="18px"
                            dangerouslySetInnerHTML={{ __html: pageText[19] }}
                        ></Text>
                    </SideText>
                    <Image>
                        <img src={BecomeHost4} alt="Become a Host" />
                    </Image>
                </Row>
            </Container>
            <BackgroundRow image={Portraits}>
                <img src={DoubleQuotes} alt="double quotes" />
                <Testimonial>
                    <img src={Person} alt="Testimonial" />
                    <TestimonialText>
                        <Text
                            white
                            size="26px"
                            dangerouslySetInnerHTML={{ __html: pageText[23] }}
                        ></Text>
                        <div>
                            <h4
                                dangerouslySetInnerHTML={{
                                    __html: pageText[24],
                                }}
                            ></h4>
                            <h5
                                dangerouslySetInnerHTML={{
                                    __html: pageText[25],
                                }}
                            ></h5>
                        </div>
                    </TestimonialText>
                </Testimonial>
            </BackgroundRow>
            <Row>
                <SideText center>
                    <Subtittle
                        size="29px"
                        dangerouslySetInnerHTML={{ __html: pageText[20] }}
                    ></Subtittle>
                    <Text
                        size="18px"
                        dangerouslySetInnerHTML={{ __html: pageText[21] }}
                    ></Text>
                    <CustomButton>
                        <Link
                            to="/dashboard/edit-place"
                            dangerouslySetInnerHTML={{ __html: pageText[22] }}
                        ></Link>
                    </CustomButton>
                </SideText>
            </Row>
        </div>
    );
};

export default BecomeHost;
